import React from 'react'

export const GreetingActiveSvg = ({
  size = 24,
  mainColor = '#9FB1E1',
  secondaryColor = '#6679BF',
}) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <defs>
      <linearGradient
        id="5e6wjmfoia"
        x1="41.789%"
        x2="63.461%"
        y1="-19.779%"
        y2="147.699%"
      >
        <stop offset="0%" stopColor={mainColor} />
        <stop offset="100%" stopColor={secondaryColor} />
      </linearGradient>
    </defs>
    <g fill="url(#5e6wjmfoia)" transform="translate(1 2)">
      <path d="M14.438 10.6h2.94c.35 0 .648.129.894.386.245.258.367.57.367.939v.442c0 .975-.328 1.808-.985 2.498-.656.69-1.448 1.035-2.376 1.035h-.84c-.228 0-.425.087-.591.262-.166.175-.25.382-.25.621v1.767c0 .24.084.446.25.621.166.175.363.262.59.262h.84c.911 0 1.78-.186 2.607-.559.827-.372 1.543-.876 2.147-1.511.604-.635 1.083-1.387 1.437-2.257.355-.87.532-1.783.532-2.74V2.65c0-.736-.245-1.362-.735-1.877C20.775.258 20.179 0 19.479 0h-5.042c-.7 0-1.295.258-1.785.773s-.735 1.14-.735 1.877v5.3c0 .736.245 1.362.735 1.877.49.515 1.086.773 1.786.773zM.735 9.827c.49.515 1.085.773 1.785.773h2.941c.35 0 .648.129.893.386.245.258.368.57.368.939v.442c0 .975-.329 1.808-.985 2.498-.656.69-1.448 1.035-2.377 1.035h-.84c-.227 0-.424.087-.59.262-.167.175-.25.382-.25.621v1.767c0 .24.083.446.25.621.166.175.363.262.59.262h.84c.911 0 1.78-.186 2.607-.559.827-.372 1.543-.876 2.147-1.511.604-.635 1.083-1.387 1.437-2.257.355-.87.532-1.783.532-2.74V2.65c0-.736-.245-1.362-.735-1.877C8.858.258 8.263 0 7.562 0H2.521C1.82 0 1.225.258.735.773S0 1.913 0 2.65v5.3c0 .736.245 1.362.735 1.877z" />
    </g>
  </svg>
)
